export const Fill = ({ children }) => (
  <span className="inline-block whitespace-nowrap rounded border border-dashed border-[#e0b93c] bg-[#fff6d9] px-1.5 py-0.5 text-[13px] font-semibold text-[#7a5a00]">
    {children}
  </span>
);

export const Section = ({ id, title, children }) => (
  <section
    id={id}
    className="scroll-mt-6 border-b border-[#eef0f9] py-[22px] last:border-b-0 last:pb-1.5"
  >
    <h2 className="mb-2.5 text-[17px] font-bold tracking-[-0.2px] text-[#1a2b6b]">
      {title}
    </h2>

    {children}
  </section>
);

export const MailLink = ({ email }) => (
  <a
    href={`mailto:${email}`}
    className="border-b border-[#2e45a8]/30 text-[#2e45a8] no-underline hover:border-[#0b1f5e] hover:text-[#0b1f5e]"
  >
    {email}
  </a>
);

export const PrivacyPolicySection = ({ id, title, children }) => (
  <section
    id={id}
    className="scroll-mt-6 border-b border-[#eef0f9] py-[22px] last:border-b-0 last:pb-1.5"
  >
    <h2 className="mb-2.5 text-[17px] font-bold tracking-[-0.2px] text-[#1a2b6b]">
      {title}
    </h2>

    {children}
  </section>
);